module.exports = __webpack_public_path__ + "img/settings_input_svideo.57664c05.svg";